import { store } from '../../../redux';
import { openNotificationPopIn } from '../../../redux/actions';
import { localStorageFuncs } from '../../helpers/';
import { AlertTypeEnum, NotificationData } from '../types';

export const npReminderHandler = (e: MessageEvent) => {
  const notification = JSON.parse(e.data) as NotificationData;
  localStorageFuncs.set('lastSyncTimeStamp', new Date().getTime());
  const title = 'Rappel NP';
  const subTitle = `Les trains suivants n'ont pas reçu de NP depuis plus de ${notification.dayCount} jours :`;
  const confirmTxt = 'OK';
  store.dispatch(
    openNotificationPopIn(
      title,
      subTitle,
      notification.data as string[],
      confirmTxt,
      AlertTypeEnum.NPReminder,
    ),
  );
};

export default npReminderHandler;
